import { CardNumberElement } from '@stripe/react-stripe-js';
import {
    StripeCardNumberElement,
    StripeCardNumberElementChangeEvent
} from '@stripe/stripe-js';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { stripeElementStyles } from '../../ElementStyles';

export const CardNumberField = ({
    error,
    onChange,
    onReady,
    className,
    placeholder
}: {
    error: {
        invalidNumber?: boolean | null;
        invalidCardType?: boolean | null;
        invalidCard?: boolean | null;
        invalidType?: boolean | null;
    };
    onChange: (arg: StripeCardNumberElementChangeEvent) => void;
    onReady: (element: StripeCardNumberElement) => void;
    className?: string;
    placeholder?: string;
}) => {
    const intl = useIntl();

    const getErrorMessage = () => {
        if (error.invalidCardType) {
            return intl.formatMessage({
                id: '_.link_debit_card.card_type_not_debit',
                defaultMessage: 'Make sure you link a debit card'
            });
        } else if (error.invalidNumber) {
            return intl.formatMessage({
                id: '_.link_debit_card.card_number_error',
                defaultMessage: 'Invalid card number'
            });
        }
        return null;
    };

    return (
        <DebitCardFieldWrapper
            label={
                <FormattedMessage
                    id="_.link_debit_card.card_number"
                    defaultMessage="Card number"
                />
            }
            error={getErrorMessage()}
            className={className}
        >
            <CardNumberElement
                onReady={onReady}
                onChange={onChange}
                options={{
                    style: stripeElementStyles,
                    disableLink: true,
                    placeholder
                }}
            />
        </DebitCardFieldWrapper>
    );
};
